import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import "./Profile.scss";
import { FiCamera } from "react-icons/fi";
import { fetchProfile, updateProfile } from "../../store/profile/actions";
import Swal from "sweetalert2";

const Profile = (props) => {
  const [state, setState] = useState({
    name: "",
    email: "",
    music_genre: "",
    nick_name: "",
    place_of_birth: "",
    current_location: "",
    musical_instruments: ""
  });

  useEffect(() => {
    setState({
      name: `${props.profile.profile.firstName} ${props.profile.profile.lastName}`,
      email: props.profile.profile.email,
      music_genre: props.profile.profile.music_genre,
      nick_name: props.profile.profile.nick_name,
      place_of_birth: props.profile.profile.place_of_birth,
      current_location: props.profile.profile.current_location,
      musical_instruments: props.profile.profile.musical_instruments,
    });
  }, [props.profile.loading]);

  const handleChange = (event) => {
    let { value, name } = event.target;
    setState({
      ...state,
      [name]: value,
    });
  };

  const handleSubmit = async () => {
    try {
      const { updateProfile } = props;
      const { name, email, music_genre, nick_name, place_of_birth, current_location, musical_instruments } = state;
      await updateProfile({ name, email, music_genre, nick_name, place_of_birth, current_location, musical_instruments });
      Swal.fire("Updated...", "", "success");
    } catch (error) {
      Swal.fire("Error...", "", "error");
    }
  };

  const checkFieldValue = (...values) => {
    if (!values[0].name || !values[0].email || !values[0].music_genre)
      return false;
    return true;
  };
  return (
    <div className="Profile container ">
      <h1 className=" font-weight-bold text-black-50 mb-5 pb-3 border-bottom w-100 text-left">
        Profile Details
      </h1>
      <div className="card shadow ">
        <div className="row top h-100 ">
          <div className="col-12 d-flex justify-content-start "></div>
          <div className="col-12 col-md-6">
            <div className="pos-relative">
              <img src="/images/bg/pp.png" alt="" className="top-img" />
              <div className="camera">
                <FiCamera className="text-white" />
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="input-wrapper">
              <div className="input-top">
                <label htmlFor="" className="input-top-label">
                  Name
                </label>
              </div>
              <input
                type="text"
                className="input form-control"
                placeholder="e.g. John Doe"
                required
                name="name"
                value={state.name}
                onChange={(e) => handleChange(e)}
              />
            </div>
            <div className="input-wrapper">
              <div className="input-top">
                <label htmlFor="" className="input-top-label">
                  Email
                </label>
              </div>
              <input
                type="email"
                className="input form-control"
                placeholder="e.g. example@gmail.com"
                required
                name="email"
                value={state.email}
                onChange={(e) => handleChange(e)}
              />
            </div>
            <div className="input-wrapper">
              <div className="input-top">
                <label htmlFor="" className="input-top-label">
                  Music Gener
                </label>
              </div>
              <input
                type="text"
                className="input form-control"
                placeholder="e.g. Folk songs"
                required
                name="music_genre"
                value={state.music_genre}
                onChange={(e) => handleChange(e)}
              />
            </div>
            <div className="input-wrapper">
              <div className="input-top">
                <label htmlFor="" className="input-top-label">
                  Nickname
                </label>
              </div>
              <input
                type="text"
                className="input form-control"
                placeholder="e.g. Freddy"
                required
                name="nick_name"
                value={state.nick_name}
                onChange={(e) => handleChange(e)}
              />
            </div>
            <div className="input-wrapper">
              <div className="input-top">
                <label htmlFor="" className="input-top-label">
                  Place of birth
                </label>
              </div>
              <input
                type="text"
                className="input form-control"
                placeholder="e.g. London"
                name="place_of_birth"
                value={state.place_of_birth}
                onChange={(e) => handleChange(e)}
              />
            </div>
            <div className="input-wrapper">
              <div className="input-top">
                <label htmlFor="" className="input-top-label">
                  Current Location
                </label>
              </div>
              <input
                type="text"
                className="input form-control"
                placeholder="e.g. London"
                name="current_location"
                value={state.current_location}
                onChange={(e) => handleChange(e)}
              />
            </div>
            <div className="input-wrapper">
              <div className="input-top">
                <label htmlFor="" className="input-top-label">
                  Music Instruments
                </label>
              </div>
              <input
                type="text"
                className="input form-control"
                placeholder="e.g. Guitar, Piano"
                name="musical_instruments"
                value={state.musical_instruments}
                onChange={(e) => handleChange(e)}
              />
            </div>
            <div className="input-wrapper d-flex">
              <button
                className="btn"
                disabled={!checkFieldValue({
                  name: state.name,
                  email: state.email,
                  music_genre: state.music_genre,
                })}
                onClick={() => handleSubmit()}
              >
                Edit Profile
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  profile: state.profile,
});

export default connect(mapStateToProps, {
  fetchProfile,
  updateProfile,
})(Profile);
